<template>
  <div>
    <ValidationObserver
      ref="validationObserverRTMP"
      v-slot="{ handleSubmit }"
    >
      <form
        novalidate="novalidate"
        @submit.prevent="handleSubmit(submit)"
        @input="handleFormChange"
      >
        <MaterialInput
          v-model="formData.streamUrl"
          v-bind="formFields.streamUrl"
        />
        <MaterialInput
          v-model="formData.streamName"
          v-bind="formFields.streamName"
        />
        <MaterialInput
          v-model="formData.port"
          v-bind="formFields.port"
        />
        <MaterialInput
          v-model="formData.username"
          v-bind="formFields.username"
        />
        <MaterialInput
          v-model="formData.password"
          v-bind="formFields.password"
        />
        <MaterialCheckbox
          :toggle="toggleSSL"
          :label="'SSL'"
          :checked="formData.useSsl"
        />
        <div class="button-wrapper">
          <Button
            :title="'Cancel'"
            :classType="'warning'"
            :eventFunction="onCancelHandle"
          />
          <Button
            :title="editDeliveryTarget ? 'Apply' : 'Add'"
            type="submit"
            :classType="'primary'"
          />
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import BaseForm from '../BaseForm.vue';
import MaterialCheckbox from '../../inputs/MaterialCheckbox.vue';
import MaterialInput from '../../inputs/MaterialInput.vue';
import CONFIG from '../../../constants/config';
import Button from '../../common/Button.vue';

export default {
  name: 'AddModalContent',
  components: {
    MaterialCheckbox,
    MaterialInput,
    Button,
  },
  extends: BaseForm,
  props: {
    formPrefix: {
      type: String,
      default: 'addDeliveryTarget',
    },
    onCancel: {
      type: Function,
      default: () => {},
    },
    editDeliveryTarget: {
      type: Object,
      default: null,
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
    itemErrors: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      validationObserver: 'validationObserverRTMP',
      formData: {
        streamName: this.getValueDeliveryFromTarget('streamName'),
        username: this.getValueDeliveryFromTarget('username'),
        password: this.getValueDeliveryFromTarget('password'),
        port: this.getValueDeliveryFromTarget('port', 1935),
        useSsl: this.getValueDeliveryFromTarget('useSsl', false),
        streamUrl: this.getStreamUrl(),
      },
      formFields: {
        streamName: {
          type: 'text',
          name: 'streamName',
          formPrefix: this.formPrefix,
          rules: {
            max: 500,
            required: true,
          },
        },
        username: {
          type: 'text',
          name: 'username',
          autocomplete: 'new-user-name',
          formPrefix: this.formPrefix,
          rules: {
            max: 255,
          },
        },
        password: {
          type: 'password',
          name: 'password',
          autocomplete: 'new-password',
          formPrefix: this.formPrefix,
          rules: {
            max: 255,
          },
        },
        port: {
          type: 'text',
          name: 'port',
          formPrefix: this.formPrefix,
          rules: {
            max: 5,
            required: true,
            numeric: true,
            max_value: 65535,
          },
        },
        streamUrl: {
          type: 'text',
          name: 'streamUrl',
          formPrefix: this.formPrefix,
          placeholder: 'rtmp://example.com/app',
          rules: {
            max: 255,
            required: true,
            is_valid_stream_url: true,
          },
        },
      },
      errorMapping: {
        streamName: [
          `${this.formPrefix}.streamName`,
        ],
        username: [
          `${this.formPrefix}.username`,
        ],
        password: [
          `${this.formPrefix}.password`,
        ],
        port: [
          `${this.formPrefix}.port`,
        ],
        streamUrl: [
          `${this.formPrefix}.host`,
          `${this.formPrefix}.appName`,
          `${this.formPrefix}.accountSchedule`,
          `${this.formPrefix}.mediaItem`,
        ],
      },
      successMessage: CONFIG.successMessages.addMediaFolderMessage,
      errorMessage: CONFIG.errorMessages.commonServerError,
    };
  },
  mounted() {
    const formErrors = this.getServerFormErrors({ form_errors: this.itemErrors });
    this.$refs[this.validationObserver].setErrors(formErrors);
  },
  methods: {
    getStreamUrl() {
      const appName = this.getValueDeliveryFromTarget('appName');
      const host = this.getValueDeliveryFromTarget('host');

      if (appName && host) {
        return `rtmp://${host}/${appName}`;
      }

      return '';
    },
    getValueDeliveryFromTarget(key, defaultValue = '') {
      return this.editDeliveryTarget && this.editDeliveryTarget[key]
        ? this.editDeliveryTarget[key]
        : defaultValue;
    },
    toggleSSL(isChecked) {
      if (isChecked !== this.formData.useSsl) {
        this.formData.useSsl = isChecked ? 1 : 0;
      }
    },
    submit() {
      const {
        streamName,
        username,
        password,
        port,
        streamUrl,
        useSsl,
      } = this.formData;

      let host = '';
      let appName = '';

      if (streamUrl) {
        const urlParts = streamUrl.split('://');
        let url = streamUrl;

        if (urlParts.length > 1) {
          url = urlParts[urlParts.length - 1];
        }

        host = url;
        appName = '';
        const pathParts = url.split('/');

        if (pathParts.length > 1) {
          appName = pathParts[pathParts.length - 1];
          host = pathParts.slice(0, -1).join('/');
        }
      }

      const data = {
        streamName,
        appName,
        host,
        port,
        username,
        password,
        useSsl: !!useSsl,
        id: this.getValueDeliveryFromTarget('id'),
      };

      this.onSubmit(data);
    },
    onCancelHandle() {
      this.onCancel();
    },
  },
};
</script>
<style scoped>
  .button-wrapper {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    padding-top: 30px;
  }

  .button-wrapper button:first-child {
    margin-right: 15px;
  }

  hr {
    border: 0 solid rgba(0, 0, 0, 0.12);
    border-top-width: thin;
    display: block;
    flex: 1 1 0;
    height: 0;
    max-height: 0;
    max-width: 100%;
    transition: inherit;
  }
</style>
